import { useTranslation } from 'react-i18next'
import { List, ListItemButton, ListItemText, ListProps } from '@mui/material'
import { AssetGroup } from '../types'
import { humanizeTimestamp } from '../utils/date'

export interface AssetGroupDetailsListProps extends Omit<ListProps, 'children'> {
  assetGroup: AssetGroup
  withTimestamps?: boolean
}

export default function AssetGroupDetailsList({
  assetGroup,
  withTimestamps = true,
  ...props
}: AssetGroupDetailsListProps) {
  const { t } = useTranslation('asset')

  return (
    <List {...props}>
      <ListItemButton key="assetGroup.name">
        <ListItemText primary={assetGroup.name} secondary={t('name')} />
      </ListItemButton>

      {assetGroup.project?.name && (
        <ListItemButton key="assetGroup.project.name">
          <ListItemText primary={assetGroup.project.name} secondary={t('project')} />
        </ListItemButton>
      )}

      {assetGroup.level?.name && (
        <ListItemButton key="assetGroup.level.name">
          <ListItemText primary={assetGroup.level.name} secondary={t('level')} />
        </ListItemButton>
      )}

      {assetGroup.lift?.name && (
        <ListItemButton key="assetGroup.lift.name">
          <ListItemText primary={assetGroup.lift.name} secondary={t('lift')} />
        </ListItemButton>
      )}

      {withTimestamps && (
        <ListItemButton key="assetGroup.createdAt">
          <ListItemText
            primary={humanizeTimestamp(assetGroup.createdAt)}
            secondary={t('createdAt')}
          />
        </ListItemButton>
      )}

      {withTimestamps && (
        <ListItemButton key="assetGroup.updatedAt">
          <ListItemText
            primary={humanizeTimestamp(assetGroup.updatedAt)}
            secondary={t('updatedAt')}
          />
        </ListItemButton>
      )}
    </List>
  )
}
